import { render, staticRenderFns } from "./select-identification-type-user.vue?vue&type=template&id=6b9486f6"
import script from "./select-identification-type-user.vue?vue&type=script&lang=js"
export * from "./select-identification-type-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports